<template>
  <div class="content content-full">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ $t('services') }}</h4>
      </div>
      <div class="card card-invoice">
        <div class="card-header">
          <div class="invoice-header">
            <h3 class="invoice-title">
              {{ formatService() }} <span v-if="service.gift">(Gift)</span>
            </h3>
            <div class="invoice-logo">
              <img src="/static/img/logo_dark_new.png" alt="Indiefy Logo">
            </div>
          </div>
          <div class="invoice-desc">
            La Ley 3048, Juan Manuel,<br>
            45066, Guadalajara, Mexico
          </div>
        </div>
        <div class="card-body">
          <div class="separator-solid"></div>
          <div class="row">
            <div class="col-md-4 info-invoice">
              <h5 class="sub">{{ $t('date') }}</h5>
              <p>{{ moment.utc(service.createdAt).format('LL') }}</p>
            </div>
            <div class="col-md-4 info-invoice">
              <h5 class="sub">Service ID</h5>
              <p>{{ service._id }}</p>
            </div>
            <div class="col-md-4 info-invoice">
              <h5 class="sub">Payer Info</h5>
              <p v-if="service.transaction && service.transaction.payer">
                {{ service.transaction.payer.payer_info.first_name }} {{ service.transaction.payer.payer_info.last_name }},<br/>{{ service.transaction.payer.payer_info.shipping_address.line1 || service.transaction.payer.payer_info.shipping_address.city }}, {{ service.transaction.payer.payer_info.shipping_address.state }}, {{ service.transaction.payer.payer_info.shipping_address.country_code }}.
              </p>
            </div>
          </div>
          <div class="separator-solid"></div>
          <h6 class="text-uppercase mt-4 mb-3 fw-bold">
            {{ $t('last_activity') }}
          </h6>
          <div class="conversations-body clearfix" v-if="service.log">
            <div class="conversations-content bg-white">
              <div class="message-content-wrapper" v-for="(log, index) in service.log" v-bind:key="`log_${index}`">
                <div class="message" :class="{ 'message-out': log.from === 'user', 'message-in': log.from !== 'user' }">
                  <div class="avatar avatar-sm" v-if="log.from !== 'user'">
                    <img :src="defaultImage" alt="..." class="avatar-img rounded-circle border border-white">
                  </div>
                  <div class="message-body">
                    <div class="message-content">
                      <div class="name" v-if="log.from !== 'user'">{{ log.from }}</div>
                      <div class="content">{{ log.message }}</div>
                    </div>
                    <div class="date">{{ moment(log.date).format('LLL') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="separator-solid"></div>
          <div class="mt-4 mb-4">
            <textarea v-if="service.status !== 'delivered'" class="form-control mt-2" v-model="message" rows="3"></textarea>
            <div class="text-right mt-2" v-if="service.status !== 'delivered'">
              <button class="btn btn-primary" type="button" @click="sendMessage()">
                {{ $t('send_message') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Services from '../services/services'
import Filters from './utils/filters'

export default {
  name: 'UserServicesDetail',
  data () {
    return {
      defaultImage: '/static/img/img-placeholder.jpg',
      moment: moment,
      loading: true,
      service: {},
      message: ''
    }
  },
  methods: {
    sendMessage: function () {
      this.service.log.push({
        date: new Date().toISOString(),
        from: 'user',
        message: this.message
      })

      this.message = ''
      this.$forceUpdate()
      Services.save(this.service).then(() => {})
    },
    formatService: function () {
      let name = ''
      let service = this.service

      if (!service._id) {
        return ''
      }

      if (service.transaction && service.transaction.transactions[0]) {
        name = service.transaction.transactions[0].custom
      } else {
        name = service.service || service._id
      }

      return Filters.capitalizeText(name.replace(/_|-/g, ' '))
    },
    getService: function () {
      this.loading = true

      Services.get(this.$route.params.id).then(response => {
        this.service = response.data
        this.loading = false
      })
    }
  },
  created: function () {
    this.getService()
  }
}
</script>

<style scoped>
@media screen and (max-width: 576px) {
  .message-content {
    max-width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserServicesDetail.vue